import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://d30345d5dbc2475090618b8672399894@o437249.ingest.sentry.io/4504044819775488',
  tracesSampleRate: 0.25,
});
